import React from 'react';

import Button from 'components/Button';

import './styles.css';

const SubmitButtons = ({
  submitting,
  triggerSubmit,
  closeModal,
  createLabel = 'Create',
  cancelLabel = 'Cancel'
}) => {
  return (
    <div className="SubmitButtons">
      <Button white className="cancel" onClick={closeModal}>
        {cancelLabel}
      </Button>
      <Button
        className="create"
        disabled={submitting}
        blue={!submitting}
        isLoading={submitting}
        onClick={triggerSubmit}>
        {createLabel}
      </Button>
    </div>
  );
};

export default SubmitButtons;
